import styled from 'styled-components';
import { media } from '../../styles/style-utils';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: left;

  &.--split {
    ${media.fromSmall`width: 50%;`}
    ${media.fromLarge`width: 25%;`}
    ${media.fromXLarge`width: 20%;`}
  }
`;

export const LeaderboardWrapper = styled.div`
  margin: 1rem;
  border-radius: 5px;
  overflow: hidden;
`;

export const Header = styled.h2`
  width: 100%;
  margin: 0;
  padding: 3.2rem 15px 2rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;

  > a {
    position: absolute;
    top: 3rem;
    right: 0.5rem;
    opacity: 0.2;
    cursor: pointer;
    display: none;
    ${media.fromSmall`display: inline-block;`}

    &:hover {
      opacity: 1;
    }
  }
`;

export const Description = styled.p`

  display: block;
  ${media.fromSmall`display: ${props => props.show ? 'block' : 'none'};`}
  padding: 0 1.5rem 1rem;
  font-size: 1.4rem;
`;

export const List = styled.ul`
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-left: 1px solid rgba(0, 0, 0, 0.85);
`;

export const Expander = styled.a`
  width: 100%;
  height: 40px;
  padding: 5px 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/components/Leaderboard/LeaderboardStyles.js